module.exports = __webpack_public_path__ + "img/invitation-step-1.52e2d626.svg";